export default __webpack_public_path__ + "static/media/registerCover.b2c9dbe6.png";